exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0